.autocomplete-item {
  @include host-component-properties-without-host;

  --paf-autocomplete-item-background: #fff;
  --paf-autocomplete-item-background-selected: #f4f3f1;
  --paf-autocomplete-item-color: #666;
  --paf-autocomplete-item-color-selected: #666;
  --paf-autocomplete-item-font-size-small: 16;
  --paf-autocomplete-item-font-size: 17;
  --paf-autocomplete-item-padding-block: 12;
  --paf-autocomplete-item-padding-inline: 16;

  background-color: var(--paf-autocomplete-item-background);
  color: var(--paf-autocomplete-item-color);
  font-size: px-to-rem(var(--paf-autocomplete-item-font-size-small));
  padding-block: px-to-rem(var(--paf-autocomplete-item-padding-block));
  padding-inline: px-to-rem(var(--paf-autocomplete-item-padding-inline));
  list-style-type: none;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
  position: relative;
  z-index: 1;
  user-select: none;

  @include mq($from: medium) {
    font-size: px-to-rem(var(--paf-autocomplete-item-font-size));
  }

  &--selected,
  &:hover,
  &:focus {
    background-color: var(--paf-autocomplete-item-background-selected);
    color: var(--paf-autocomplete-item-color-selected);
  }

  &:hover {
    @include forced-colors {
      background-color: ButtonText;
    }
  }

  &--selected {
    @include focus-visible;

    @include forced-colors {
      color: ButtonText;
      outline-color: ButtonText;
    }

    outline-offset: 0;
    z-index: 2;
  }
}
